import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from '../config/config';

/* ─── SEFAMS Blue Palette (from LoginForm) ─── */
const C = {
  navy: "#0f1f3d",
  navyMid: "#162447",
  blue: "#1a56db",
  blueMid: "#1e40af",
  accent: "#4a9eff",
  sky: "#22d3ee",
  white: "#ffffff",
  offWhite:"#f8fafd",
  border: "#e2e8f5",
  muted: "#8a9ab8",
  mutedLt: "#b0bdd0",
  label: "#4b607a",
  text: "#0f1f3d",
};
const courses = [
  {
    id:1, code:"BSN-101",
    title:"Bachelor of Science in Nursing",
    duration:"4 Years", price:480000, badge:"Most Popular",
    description:"A comprehensive undergraduate programme that prepares students for professional nursing practice. Covers anatomy, pharmacology, clinical skills and patient-centred care across diverse healthcare settings.",
    highlights:["Clinical Rotations","Pharmacology","Community Health","Leadership"],
    seats:60,
  },
  {
    id:2, code:"DIP-201",
    title:"Diploma in Nursing",
    duration:"3 Years", price:290000, badge:"Fast Track",
    description:"An accelerated diploma programme producing competent, compassionate registered nurses ready for immediate deployment in hospitals, clinics and community health centres.",
    highlights:["Practical Training","Emergency Care","Midwifery","Paediatrics"],
    seats:80,
  },
  {
    id:3, code:"MSN-301",
    title:"Master of Science in Nursing",
    duration:"2 Years", price:620000, badge:"Advanced",
    description:"Graduate-level study for experienced nurses seeking specialisation in clinical practice, nursing education or healthcare administration. Research-intensive with evidence-based focus.",
    highlights:["Research Methods","Specialisation","Leadership","Advanced Practice"],
    seats:30,
  },
  {
    id:4, code:"CPN-401",
    title:"Certificate in Psychiatric Nursing",
    duration:"1 Year", price:145000, badge:"Specialist",
    description:"Focused training in mental health nursing, equipping practitioners with assessment, therapy and therapeutic communication skills for patients with psychiatric and psychosocial needs.",
    highlights:["Mental Health","Therapeutic Comms","Crisis Care","Counselling"],
    seats:40,
  },
];
const STEPS = ["Personal Info","Education","Documents","Review"];
function fmtKES(n){ return `KES ${n.toLocaleString()}`; }
const css = `
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap');
*{box-sizing:border-box;margin:0;padding:0;}
@keyframes fadeUp {from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}
@keyframes shimmer {from{left:-100%}to{left:200%}}
@keyframes floatUp {0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}
@keyframes pulseGlow{0%,100%{opacity:.4}50%{opacity:.9}}
@keyframes spin {to{transform:rotate(360deg)}}
.nr{font-family:'Quicksand',sans-serif;background:#f8fafd;min-height:100vh;color:#0f1f3d;}
/* HERO */
.hero{
  background:linear-gradient(135deg,#0f1f3d 0%,#162447 55%,#1B2F5E 100%);
  padding:48px 20px 68px;position:relative;overflow:hidden;
}
.hero::before{
  content:'';position:absolute;inset:0;
  background:radial-gradient(ellipse at 20% 30%,#1a56db28 0%,transparent 60%),
             radial-gradient(ellipse at 80% 70%,#22d3ee14 0%,transparent 55%);
  pointer-events:none;
}
.hero-grid{
  position:absolute;inset:0;pointer-events:none;
  background-image:linear-gradient(#4a9eff0a 1px,transparent 1px),linear-gradient(90deg,#4a9eff0a 1px,transparent 1px);
  background-size:48px 48px;
}
.hero-inner{max-width:860px;margin:0 auto;position:relative;z-index:1;}
.hero-brand{display:flex;align-items:center;gap:12px;margin-bottom:26px;}
.hero-icon{
  width:46px;height:46px;border-radius:13px;
  background:linear-gradient(135deg,#1a56db,#4a9eff);
  display:flex;align-items:center;justify-content:center;font-size:20px;
  box-shadow:0 4px 20px #1a56db55;animation:floatUp 4s ease-in-out infinite;flex-shrink:0;
}
.hero-brand-name{font-size:17px;font-weight:700;color:#fff;}
.hero-brand-sub{font-size:9px;color:rgba(160,200,255,.5);letter-spacing:.18em;text-transform:uppercase;margin-top:2px;}
.hero h1{font-size:clamp(24px,5vw,44px);font-weight:700;color:#fff;line-height:1.18;letter-spacing:-.02em;margin-bottom:12px;}
.hero-grad{background:linear-gradient(90deg,#4a9eff,#22d3ee);-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
.hero p{font-size:14px;color:rgba(160,200,255,.72);max-width:440px;line-height:1.75;font-weight:500;margin-bottom:28px;}
.hero-stats{display:flex;gap:20px;flex-wrap:wrap;}
.hero-stat{display:flex;align-items:center;gap:9px;}
.hs-icon{font-size:18px;}
.hs-title{font-size:12px;font-weight:700;color:#fff;}
.hs-sub{font-size:10px;color:rgba(255,255,255,.45);font-weight:500;}
/* TAB BAR */
.tab-bar{background:#fff;border-bottom:1px solid #e2e8f5;position:sticky;top:0;z-index:100;}
.tab-inner{max-width:860px;margin:0 auto;padding:0 20px;display:flex;overflow-x:auto;}
.tab-btn{
  padding:15px 20px;border:none;background:transparent;
  font-family:'Quicksand',sans-serif;font-size:13px;font-weight:700;
  cursor:pointer;display:flex;align-items:center;gap:6px;
  border-bottom:2.5px solid transparent;transition:all .2s;white-space:nowrap;
}
.tab-btn.active{color:#1a56db;border-bottom-color:#1a56db;}
.tab-btn:not(.active){color:#b0bdd0;}
/* CONTENT */
.content{max-width:860px;margin:0 auto;padding:28px 20px 80px;}
/* COURSE CARDS */
.sec-head{margin-bottom:24px;}
.sec-head h2{font-size:20px;font-weight:700;letter-spacing:-.01em;margin-bottom:5px;}
.sec-head p{color:#8a9ab8;font-size:13px;font-weight:500;}
.course-grid{display:grid;gap:16px;}
.course-card{
  background:#fff;border-radius:16px;border:1.5px solid #e2e8f5;
  padding:22px;transition:all .25s ease;cursor:pointer;
}
.course-card:hover{border-color:#1a56db;transform:translateY(-2px);box-shadow:0 8px 30px #1a56db18;}
.cc-top{display:flex;justify-content:space-between;align-items:flex-start;gap:14px;flex-wrap:wrap;}
.cc-left{flex:1;min-width:200px;}
.cc-right{text-align:right;flex-shrink:0;min-width:130px;}
.tags{display:flex;align-items:center;gap:7px;margin-bottom:9px;flex-wrap:wrap;}
.tag{font-size:10px;font-weight:700;padding:3px 9px;border-radius:6px;letter-spacing:.05em;white-space:nowrap;}
.tag-code{background:#f1f5fb;color:#8a9ab8;}
.tag-badge{background:#1a56db12;color:#1a56db;}
.tag-dur{background:transparent;color:#b0bdd0;font-size:10px;}
.cc-title{font-size:16px;font-weight:700;margin-bottom:7px;letter-spacing:-.01em;}
.cc-desc{color:#8a9ab8;font-size:12.5px;line-height:1.7;margin-bottom:12px;font-weight:500;}
.hl{display:flex;gap:6px;flex-wrap:wrap;}
.hl span{font-size:11px;font-weight:600;color:#1a56db;background:#1a56db0e;padding:3px 10px;border-radius:20px;}
.price-lbl{font-size:9px;font-weight:700;color:#b0bdd0;letter-spacing:.08em;text-transform:uppercase;margin-bottom:2px;}
.price-val{font-size:22px;font-weight:700;letter-spacing:-.02em;line-height:1;color:#0f1f3d;}
.price-sub{font-size:10px;color:#b0bdd0;font-weight:500;margin-bottom:10px;}
.seats-txt{font-size:11px;color:#8a9ab8;font-weight:600;margin-bottom:9px;}
.apply-btn{
  padding:9px 16px;border:none;border-radius:10px;
  background:linear-gradient(135deg,#0f1f3d,#1a56db);
  color:#fff;font-family:'Quicksand',sans-serif;
  font-size:12px;font-weight:700;cursor:pointer;
  letter-spacing:.03em;transition:opacity .2s,transform .15s;
  width:100%;white-space:nowrap;position:relative;overflow:hidden;
}
.apply-btn::after{
  content:'';position:absolute;top:0;left:-100%;width:60%;height:100%;
  background:linear-gradient(90deg,transparent,rgba(255,255,255,.18),transparent);
  animation:shimmer 2.5s ease infinite;
}
.apply-btn:hover{transform:translateY(-1px);opacity:.9;}
/* FEE SUMMARY */
.fee-summary{margin-top:36px;background:#fff;border-radius:16px;border:1.5px solid #e2e8f5;padding:22px;}
.fee-summary h3{font-size:14px;font-weight:700;margin-bottom:16px;}
.fee-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(130px,1fr));gap:12px;}
.fee-item{background:#f8fafd;border-radius:10px;padding:13px;border-left:3px solid #1a56db;}
.fi-dur{font-size:9px;font-weight:700;color:#b0bdd0;text-transform:uppercase;letter-spacing:.06em;margin-bottom:2px;}
.fi-code{font-size:11px;font-weight:700;color:#0f1f3d;margin-bottom:2px;}
.fi-amt{font-size:14px;font-weight:700;color:#1a56db;}
.fi-sub{font-size:9px;color:#b0bdd0;font-weight:500;}
.fee-note{margin-top:12px;font-size:11px;color:#b0bdd0;font-weight:500;line-height:1.65;}
/* APPLY — COURSE SELECTOR */
.cs{background:#fff;border-radius:16px;border:1.5px solid #e2e8f5;padding:18px;margin-bottom:22px;}
.cs-label{font-size:9px;font-weight:700;color:#b0bdd0;letter-spacing:.1em;text-transform:uppercase;margin-bottom:9px;}
.cs-btns{display:flex;gap:7px;flex-wrap:wrap;}
.cs-btn{
  padding:7px 13px;border-radius:9px;font-family:'Quicksand',sans-serif;
  font-size:11.5px;font-weight:700;cursor:pointer;transition:all .2s;white-space:nowrap;
}
.cs-btn.sel{border:2px solid #1a56db;background:#1a56db0e;color:#1a56db;}
.cs-btn:not(.sel){border:1.5px solid #e2e8f5;background:#fff;color:#8a9ab8;}
.cs-sel{
  margin-top:9px;padding:8px 13px;background:#1a56db09;
  border-radius:8px;display:flex;justify-content:space-between;flex-wrap:wrap;gap:5px;
}
.cs-sel-name{font-size:11.5px;font-weight:600;color:#1a56db;}
.cs-sel-price{font-size:11.5px;font-weight:700;color:#1a56db;}
/* STEPPER */
.stepper{display:flex;align-items:center;margin-bottom:24px;}
.sn{
  width:29px;height:29px;border-radius:50%;display:flex;align-items:center;justify-content:center;
  font-size:11px;font-weight:700;flex-shrink:0;transition:all .3s;
}
.sn.done {background:linear-gradient(135deg,#0f1f3d,#1a56db);color:#fff;}
.sn.active{background:linear-gradient(135deg,#1a56db,#4a9eff);color:#fff;box-shadow:0 0 0 3px #1a56db22;}
.sn.idle {background:#f1f5fb;color:#b0bdd0;}
.sl{font-size:11px;font-weight:700;white-space:nowrap;margin-left:5px;}
.sl.active{color:#0f1f3d;}
.sl.done{color:#1a56db;}
.sl.idle{color:#b0bdd0;}
.sline{flex:1;height:2px;margin:0 8px;transition:background .3s;}
.sline.done{background:#1a56db;}
.sline.idle{background:#e2e8f5;}
@media(max-width:480px){.sl{display:none;}.sn{margin:0 3px;}.sline{margin:0 4px;}}
/* FORM CARD */
.form-card{
  background:#fff;border-radius:16px;border:1.5px solid #e2e8f5;
  padding:26px 22px;position:relative;overflow:hidden;
}
.form-card::before{
  content:'';position:absolute;top:0;left:0;right:0;height:2px;
  background:linear-gradient(90deg,#0f1f3d,#1a56db,#4a9eff);
}
.sh{display:flex;align-items:center;gap:9px;margin-bottom:16px;}
.sh-icon{
  width:29px;height:29px;border-radius:8px;display:flex;align-items:center;justify-content:center;
  font-size:13px;background:linear-gradient(135deg,#0f1f3d,#1a56db);
}
.sh-title{font-weight:700;font-size:13.5px;}
/* FIELDS */
.fields{display:flex;flex-direction:column;gap:13px;}
.field{display:flex;flex-direction:column;gap:4px;}
.field label{font-size:9.5px;font-weight:700;color:#4b607a;text-transform:uppercase;letter-spacing:.07em;}
.field input,.field select,.field textarea{
  width:100%;padding:10px 13px;
  border:1.5px solid #e2e8f5;border-radius:9px;
  font-family:'Quicksand',sans-serif;font-size:13px;font-weight:500;
  color:#0f1f3d;background:#fff;outline:none;
  transition:border-color .2s,box-shadow .2s;appearance:none;
}
.field input:focus,.field select:focus,.field textarea:focus{border-color:#1a56db;box-shadow:0 0 0 3px #1a56db14;}
.field input::placeholder{color:#b0bdd0;}
.g2{display:grid;grid-template-columns:1fr 1fr;gap:13px;}
.g3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:13px;}
@media(max-width:540px){.g2,.g3{grid-template-columns:1fr;}}
.div-sec{border-top:1px solid #f1f5fb;padding-top:18px;margin-top:4px;}
.div-lbl{font-size:9.5px;font-weight:700;color:#b0bdd0;text-transform:uppercase;letter-spacing:.07em;margin-bottom:11px;}
/* UPLOADS */
.upload-item{
  background:#f8fafd;border-radius:12px;padding:16px;
  border:1.5px dashed #d1d9ee;transition:border-color .2s;
}
.upload-item.done{border:1.5px solid #1a56db;}
.upload-row{display:flex;align-items:flex-start;gap:11px;}
.u-ico{font-size:20px;flex-shrink:0;margin-top:1px;}
.u-title{font-size:12px;font-weight:700;color:#0f1f3d;margin-bottom:2px;}
.u-desc{font-size:11px;color:#b0bdd0;font-weight:500;line-height:1.6;margin-bottom:9px;}
.u-lbl{
  display:inline-flex;align-items:center;gap:5px;
  padding:6px 14px;border-radius:8px;
  font-family:'Quicksand',sans-serif;font-size:11px;font-weight:700;cursor:pointer;
}
.u-lbl.empty{background:#fff;color:#1a56db;border:1.5px solid #1a56db;}
.u-lbl.filled{background:#1a56db;color:#fff;border:1.5px solid #1a56db;}
.u-name{font-size:10.5px;color:#1a56db;font-weight:600;}
/* REVIEW */
.rev-prog{border-radius:11px;padding:14px 16px;margin-bottom:18px;border-left:4px solid #1a56db;background:#1a56db08;}
.rp-sub{font-size:9.5px;font-weight:700;color:#1a56db;letter-spacing:.08em;text-transform:uppercase;margin-bottom:4px;}
.rp-name{font-size:14px;font-weight:700;color:#0f1f3d;}
.rp-meta{font-size:11px;color:#1a56db;font-weight:600;margin-top:3px;}
.rev-sec{background:#f8fafd;border-radius:11px;padding:16px;margin-bottom:12px;}
.rs-title{font-size:9.5px;font-weight:700;color:#b0bdd0;text-transform:uppercase;letter-spacing:.08em;margin-bottom:11px;}
.rev-row{display:flex;justify-content:space-between;padding:5px 0;border-bottom:1px solid #e2e8f5;gap:10px;}
.rev-row:last-child{border-bottom:none;}
.rr-k{font-size:11.5px;color:#b0bdd0;font-weight:600;flex-shrink:0;}
.rr-v{font-size:11.5px;color:#0f1f3d;font-weight:600;text-align:right;}
.warn-box{background:#fffbeb;border-radius:9px;padding:11px 14px;border:1px solid #fcd34d;margin-top:8px;}
.warn-box p{font-size:11.5px;color:#92400e;font-weight:600;line-height:1.65;}
/* NAV BUTTONS */
.form-nav{display:flex;justify-content:space-between;margin-top:26px;padding-top:18px;border-top:1px solid #f1f5fb;gap:10px;}
.btn-back{
  padding:10px 20px;border:1.5px solid #e2e8f5;border-radius:10px;
  background:#fff;color:#8a9ab8;font-family:'Quicksand',sans-serif;
  font-size:12.5px;font-weight:700;cursor:pointer;transition:border-color .2s;
}
.btn-back:disabled{color:#d1d9ee;cursor:not-allowed;}
.btn-back:not(:disabled):hover{border-color:#1a56db;color:#1a56db;}
.btn-next{
  padding:10px 26px;border:none;border-radius:10px;
  background:linear-gradient(135deg,#0f1f3d,#1a56db);
  color:#fff;font-family:'Quicksand',sans-serif;
  font-size:12.5px;font-weight:700;cursor:pointer;
  box-shadow:0 4px 16px #1a56db33;
  transition:transform .15s,box-shadow .15s;
  position:relative;overflow:hidden;white-space:nowrap;
}
.btn-next::after{
  content:'';position:absolute;top:0;left:-100%;width:60%;height:100%;
  background:linear-gradient(90deg,transparent,rgba(255,255,255,.18),transparent);
  animation:shimmer 2.5s ease infinite;
}
.btn-next:hover{transform:translateY(-1px);box-shadow:0 6px 22px #1a56db44;}
/* SUCCESS */
.success-wrap{text-align:center;padding:60px 20px;animation:fadeUp .5s ease;}
.success-ring{
  width:74px;height:74px;border-radius:50%;margin:0 auto 20px;
  background:linear-gradient(135deg,#0f1f3d,#1a56db);
  display:flex;align-items:center;justify-content:center;
  font-size:30px;color:#fff;box-shadow:0 8px 28px #1a56db33;
}
.success-wrap h2{font-size:24px;font-weight:700;letter-spacing:-.02em;margin-bottom:9px;}
.success-wrap p{color:#8a9ab8;font-size:13.5px;font-weight:500;max-width:400px;margin:0 auto 6px;line-height:1.7;}
.ref-box{
  background:#f8fafd;border-radius:13px;padding:16px 26px;
  display:inline-block;margin:24px auto;border:1.5px solid #e2e8f5;
}
.ref-lbl{font-size:9.5px;font-weight:700;color:#b0bdd0;letter-spacing:.08em;text-transform:uppercase;margin-bottom:4px;}
.ref-code{font-size:20px;font-weight:700;color:#1a56db;letter-spacing:.1em;}
.btn-outline{
  padding:10px 24px;border:1.5px solid #1a56db;border-radius:10px;
  background:#fff;color:#1a56db;font-family:'Quicksand',sans-serif;
  font-size:12.5px;font-weight:700;cursor:pointer;margin-top:6px;
  transition:background .2s;
}
.btn-outline:hover{background:#1a56db08;}
`;
export default function AddStudent() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("courses");
  const [sel, setSel] = useState(null);
  const [step, setStep] = useState(0);
  const [sub, setSub] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refNum] = useState(()=>`KNC-2025-${Math.floor(10000+Math.random()*90000)}`);
  const blank = {
    firstName:"",lastName:"",email:"",phone:"",dob:"",gender:"",
    nationalId:"",county:"",postalAddress:"",nextOfKin:"",kinPhone:"",
    kcseYear:"",kcseIndex:"",kcseGrade:"",school:"",
    engGrade:"",mathGrade:"",bioGrade:"",chemGrade:"",
    prevDegree:"",institution:"",gradYear:"",
    idDoc:"",kcseDoc:"",photoDoc:"",medicalDoc:"",
  };
  const [fd, setFd] = useState(blank);
  const upd = (k,v) => setFd(p=>({...p,[k]:v}));
  const inp = (k,ph,type="text") => (
    <input type={type} placeholder={ph} value={fd[k]} onChange={e=>upd(k,e.target.value)} disabled={loading} />
  );
  const sel2 = (k,opts) => (
    <select value={fd[k]} onChange={e=>upd(k,e.target.value)} disabled={loading}>
      <option value="">Select…</option>
      {opts.map(o=><option key={o}>{o}</option>)}
    </select>
  );
  const fld = (lbl,el) => <div className="field"><label>{lbl}</label>{el}</div>;
  const grades = ["A","A-","B+","B","B-","C+","C","C-","D+","D","D-","E"];
  const counties= ["Nairobi","Mombasa","Kisumu","Nakuru","Eldoret","Machakos","Meru","Nyeri","Thika","Kakamega","Kisii","Kitale","Garissa","Isiolo","Wajir","Lamu"];
  const SH = ({icon,label}) => (
    <div className="sh">
      <div className="sh-icon">{icon}</div>
      <span className="sh-title">{label}</span>
    </div>
  );

  const handleSubmit = async () => {
    if (!sel) {
      alert("Please select a programme");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("course_id", sel.id);
    formData.append("course_code", sel.code);
    formData.append("first_name", fd.firstName);
    formData.append("last_name", fd.lastName);
    formData.append("email", fd.email);
    formData.append("phone", fd.phone);
    formData.append("dob", fd.dob);
    formData.append("gender", fd.gender);
    formData.append("national_id", fd.nationalId);
    formData.append("county", fd.county);
    formData.append("postal_address", fd.postalAddress);
    formData.append("next_of_kin", fd.nextOfKin);
    formData.append("kin_phone", fd.kinPhone);
    formData.append("kcse_year", fd.kcseYear);
    formData.append("kcse_index", fd.kcseIndex);
    formData.append("kcse_grade", fd.kcseGrade);
    formData.append("school", fd.school);
    formData.append("eng_grade", fd.engGrade);
    formData.append("math_grade", fd.mathGrade);
    formData.append("bio_grade", fd.bioGrade);
    formData.append("chem_grade", fd.chemGrade);
    formData.append("prev_degree", fd.prevDegree);
    formData.append("institution", fd.institution);
    formData.append("grad_year", fd.gradYear);
    // Files (currently names; replace with actual File objects if needed)
    // formData.append("id_doc", fd.idDocFile); etc.

    try {
      await axios.post(`${config.API_URL}/api/savestudents`, formData, {
        headers: { 
          "Content-Type": "multipart/form-data",
          "Accept": "application/json"
        },
        withCredentials: true
      });
      setSub(true);
    } catch (error) {
      console.error(error);
      alert("Submission failed. Please check your data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="nr">
      <style>{css}</style>
      {/* HERO */}
      <div className="hero">
        <div className="hero-grid"/>
        <div className="hero-inner">
          <div className="hero-brand">
            <div className="hero-icon">🏥</div>
            <div>
              <div className="hero-brand-name">Kenya Nursing College</div>
              <div className="hero-brand-sub">Accredited Institution · MOH Kenya</div>
            </div>
          </div>
          <h1>Add New <span className="hero-grad">Student</span></h1>
          <p>Complete the admission process for the 2025/2026 academic year. All fields marked * are required.</p>
          <div className="hero-stats">
            {[["🎓","4 Programmes","BSN to Specialist"],["📅","Jan & Sep Intake","Two intakes yearly"],["🏆","MOH Accredited","Nationally recognised"]].map(([ic,t,s])=>(
              <div className="hero-stat" key={t}>
                <span className="hs-icon">{ic}</span>
                <div><div className="hs-title">{t}</div><div className="hs-sub">{s}</div></div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* TAB BAR */}
      <div className="tab-bar">
        <div className="tab-inner">
          {[{id:"courses",icon:"📚",label:"Courses & Fees"},{id:"apply",icon:"✍️",label:"Add Student"}].map(t=>(
            <button key={t.id} className={`tab-btn${tab===t.id?" active":""}`}
              onClick={()=>{setTab(t.id);setStep(0);setSub(false);setSel(null);setFd(blank);}}>
              <span>{t.icon}</span>{t.label}
            </button>
          ))}
        </div>
      </div>
      <div className="content">
        {/* ═══ COURSES TAB ═══ */}
        {tab==="courses" && (
          <>
            <div className="sec-head">
              <h2>Our Programmes</h2>
              <p>Choose from our nationally accredited nursing programmes</p>
            </div>
            <div className="course-grid">
              {courses.map(c=>(
                <div key={c.id} className="course-card">
                  <div className="cc-top">
                    <div className="cc-left">
                      <div className="tags">
                        <span className="tag tag-code">{c.code}</span>
                        <span className="tag tag-badge">{c.badge}</span>
                        <span className="tag tag-dur">⏱ {c.duration}</span>
                      </div>
                      <div className="cc-title">{c.title}</div>
                      <div className="cc-desc">{c.description}</div>
                      <div className="hl">
                        {c.highlights.map(h=><span key={h}>{h}</span>)}
                      </div>
                    </div>
                    <div className="cc-right">
                      <div className="price-lbl">Annual Fee</div>
                      <div className="price-val">{fmtKES(c.price)}</div>
                      <div className="price-sub">per year</div>
                      <div className="seats-txt">🪑 {c.seats} seats available</div>
                      <button className="apply-btn"
                        onClick={()=>{setSel(c);setTab("apply");}}>
                        Admit Student to This Course →
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="fee-summary">
              <h3>Fee Summary</h3>
              <div className="fee-grid">
                {courses.map(c=>(
                  <div className="fee-item" key={c.id}>
                    <div className="fi-dur">{c.duration}</div>
                    <div className="fi-code">{c.code}</div>
                    <div className="fi-amt">{fmtKES(c.price)}</div>
                    <div className="fi-sub">per year</div>
                  </div>
                ))}
              </div>
              <p className="fee-note">* Fees payable per academic year. HELB loans &amp; bursaries accepted. Payment plans available. All fees inclusive of tuition, clinical attachment and examinations.</p>
            </div>
          </>
        )}
        {/* ═══ APPLY TAB ═══ */}
        {tab==="apply" && !sub && (
          <>
            <div className="cs">
              <div className="cs-label">Applying For</div>
              <div className="cs-btns">
                {courses.map(c=>(
                  <button key={c.id} className={`cs-btn${sel?.id===c.id?" sel":""}`}
                    onClick={()=>setSel(c)}>{c.code}</button>
                ))}
              </div>
              {sel && (
                <div className="cs-sel">
                  <span className="cs-sel-name">{sel.title} · {sel.duration}</span>
                  <span className="cs-sel-price">{fmtKES(sel.price)} / yr</span>
                </div>
              )}
            </div>
            {/* Stepper */}
            <div className="stepper">
              {STEPS.map((s,i)=>{
                const state = i<step?"done":i===step?"active":"idle";
                return (
                  <div key={s} style={{display:"flex",alignItems:"center",flex:i<STEPS.length-1?1:"none"}}>
                    <div className={`sn ${state}`}>{i<step?"✓":i+1}</div>
                    <span className={`sl ${state}`}>{s}</span>
                    {i<STEPS.length-1 && <div className={`sline ${i<step?"done":"idle"}`}/>}
                  </div>
                );
              })}
            </div>
            <div className="form-card">
              {/* STEP 0 */}
              {step===0 && (
                <div className="fields">
                  <SH icon="👤" label="Personal Information"/>
                  <div className="g2">
                    {fld("First Name *",inp("firstName","e.g. Amina"))}
                    {fld("Last Name *",inp("lastName","e.g. Wanjiku"))}
                  </div>
                  <div className="g2">
                    {fld("Email Address *",inp("email","amina@email.com","email"))}
                    {fld("Phone Number *",inp("phone","+254 700 000 000","tel"))}
                  </div>
                  <div className="g2">
                    {fld("Date of Birth *",inp("dob","","date"))}
                    {fld("Gender *",sel2("gender",["Female","Male","Prefer not to say"]))}
                  </div>
                  <div className="g2">
                    {fld("National ID / Passport *",inp("nationalId","12345678"))}
                    {fld("County of Residence *",sel2("county",counties))}
                  </div>
                  {fld("Postal Address",inp("postalAddress","P.O. Box 12345 - 00100 Nairobi"))}
                  <div className="div-sec">
                    <SH icon="👨‍👩‍👧" label="Next of Kin"/>
                    <div className="g2">
                      {fld("Full Name *",inp("nextOfKin","Jane Doe"))}
                      {fld("Phone Number *",inp("kinPhone","+254 700 000 000","tel"))}
                    </div>
                  </div>
                </div>
              )}
              {/* STEP 1 */}
              {step===1 && (
                <div className="fields">
                  <SH icon="🎓" label="Academic Background"/>
                  <div className="g3">
                    {fld("KCSE Year *",inp("kcseYear","2023","number"))}
                    {fld("KCSE Index No.",inp("kcseIndex","12345678/001"))}
                    {fld("Mean Grade *",sel2("kcseGrade",grades))}
                  </div>
                  {fld("Secondary School Name *",inp("school","Nairobi School"))}
                  <div className="div-sec">
                    <div className="div-lbl">Subject Grades</div>
                    <div className="g2">
                      {fld("English",sel2("engGrade",grades))}
                      {fld("Mathematics / Alt",sel2("mathGrade",grades))}
                      {fld("Biology",sel2("bioGrade",grades))}
                      {fld("Chemistry / Physics",sel2("chemGrade",grades))}
                    </div>
                  </div>
                  <div className="div-sec">
                    <div className="div-lbl">Previous Tertiary Education (if any)</div>
                    <div className="g3">
                      {fld("Qualification",inp("prevDegree","e.g. Diploma in Health"))}
                      {fld("Institution",inp("institution","e.g. KNH"))}
                      {fld("Year Graduated",inp("gradYear","2022","number"))}
                    </div>
                  </div>
                </div>
              )}
              {/* STEP 2 */}
              {step===2 && (
                <div className="fields">
                  <SH icon="📎" label="Document Uploads"/>
                  <p style={{color:C.mutedLt,fontSize:"12.5px",fontWeight:500,lineHeight:1.7}}>
                    Upload clear scanned copies or photos. PDF, JPG or PNG — max 5 MB each.
                  </p>
                  {[
                    {k:"idDoc", icon:"🪪",title:"National ID / Passport *", desc:"Clear photo of both sides of ID or bio-data page of passport"},
                    {k:"kcseDoc", icon:"📜",title:"KCSE Certificate / Result Slip *",desc:"Official KCSE results slip or certificate from KNEC"},
                    {k:"photoDoc",icon:"🤳",title:"Passport-size Photograph *", desc:"Recent colour photo, plain white background, front-facing"},
                    {k:"medicalDoc",icon:"🏥",title:"Medical Certificate *", desc:"From a registered medical practitioner — within last 3 months"},
                  ].map(doc=>(
                    <div key={doc.k} className={`upload-item${fd[doc.k]?" done":""}`}>
                      <div className="upload-row">
                        <div className="u-ico">{doc.icon}</div>
                        <div style={{flex:1}}>
                          <div className="u-title">{doc.title}</div>
                          <div className="u-desc">{doc.desc}</div>
                          <div style={{display:"flex",alignItems:"center",gap:"7px",flexWrap:"wrap"}}>
                            <label className={`u-lbl${fd[doc.k]?" filled":" empty"}`}>
                              {fd[doc.k]?"✓ Uploaded":"Choose File"}
                              <input type="file" accept=".pdf,.jpg,.jpeg,.png"
                                onChange={e=>upd(doc.k,e.target.files[0]?.name||"")}
                                style={{display:"none"}}/>
                            </label>
                            {fd[doc.k]&&<span className="u-name">{fd[doc.k]}</span>}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {/* STEP 3 */}
              {step===3 && (
                <div>
                  <SH icon="✅" label="Review Your Application"/>
                  {sel && (
                    <div className="rev-prog">
                      <div className="rp-sub">Programme Selected</div>
                      <div className="rp-name">{sel.title}</div>
                      <div className="rp-meta">{sel.code} · {sel.duration} · {fmtKES(sel.price)} / year</div>
                    </div>
                  )}
                  {[
                    {title:"Personal Details",rows:[
                      ["Full Name",`${fd.firstName} ${fd.lastName}`],["Email",fd.email],
                      ["Phone",fd.phone],["Date of Birth",fd.dob],["Gender",fd.gender],
                      ["National ID",fd.nationalId],["County",fd.county],
                      ["Next of Kin",`${fd.nextOfKin} · ${fd.kinPhone}`],
                    ]},
                    {title:"Academic Details",rows:[
                      ["KCSE Year",fd.kcseYear],["Mean Grade",fd.kcseGrade],
                      ["School",fd.school],["Biology",fd.bioGrade],["Chemistry",fd.chemGrade],["English",fd.engGrade],
                    ]},
                    {title:"Documents",rows:[
                      ["National ID",fd.idDoc||"Not uploaded"],["KCSE Certificate",fd.kcseDoc||"Not uploaded"],
                      ["Passport Photo",fd.photoDoc||"Not uploaded"],["Medical Certificate",fd.medicalDoc||"Not uploaded"],
                    ]},
                  ].map(sec=>(
                    <div className="rev-sec" key={sec.title}>
                      <div className="rs-title">{sec.title}</div>
                      {sec.rows.map(([k,v])=>v&&(
                        <div className="rev-row" key={k}>
                          <span className="rr-k">{k}</span>
                          <span className="rr-v">{v||"—"}</span>
                        </div>
                      ))}
                    </div>
                  ))}
                  <div className="warn-box">
                    <p>⚠️ By submitting, you confirm all information is accurate. Falsification may result in disqualification and legal action.</p>
                  </div>
                </div>
              )}
              {/* Navigation */}
              <div className="form-nav">
                <button className="btn-back" disabled={step===0 || loading}
                  onClick={()=>setStep(s=>Math.max(0,s-1))}>← Back</button>
                <button className="btn-next" disabled={loading}
                  onClick={()=>step<STEPS.length-1?setStep(s=>s+1):handleSubmit()}>
                  {loading ? "Submitting..." : step===STEPS.length-1?"Submit Application 🎓":"Continue →"}
                </button>
              </div>
            </div>
          </>
        )}
        {/* ═══ SUCCESS ═══ */}
        {tab==="apply" && sub && (
          <div className="success-wrap">
            <div className="success-ring">✓</div>
            <h2>Student Added Successfully!</h2>
            <p>Thank you. Application for <strong style={{color:C.blue}}>{sel?.title}</strong> has been received with reference <strong>{refNum}</strong>.</p>
            <p style={{color:C.mutedLt,fontSize:"12px"}}>
              Our team will review documents within 5–7 working days.
            </p>
            <div className="ref-box">
              <div className="ref-lbl">Application Reference</div>
              <div className="ref-code">{refNum}</div>
            </div>
            <br/>
            <button className="btn-outline"
              onClick={()=>{setSub(false);setStep(0);setTab("courses");setSel(null);setFd(blank);}}>
              Add Another Student
            </button>
          </div>
        )}
      </div>
    </div>
  );
}